export default Object.freeze({
  ADMINISTRATOR: "administrator",
  NAVIGATION_OFFICE: "navigation_office",
  OBSERVER: "observer",
  NONE: "none"
});
